<script>
import { GlAlert, GlLink } from '@gitlab/ui';
import { PROMO_CODE_INFO_LINK } from '~/javascripts/subscription/constants';

export default {
  name: 'PromotionalOfferAlert',
  components: {
    GlAlert,
    GlLink,
  },
  PROMO_CODE_INFO_LINK,
};
</script>
<template>
  <gl-alert :dismissible="false" data-testid="promotional-offer-alert" class="gl-mb-5">
    Pricing reflective of
    <gl-link :href="$options.PROMO_CODE_INFO_LINK" target="_blank">limited-time offer</gl-link>.
  </gl-alert>
</template>
